import Reflux from 'reflux';

export default Reflux.createActions(['fetchOrg', 'fetchOrgError', 'update']);
